export const PREVIEW_MODE_PARAM = '__preview';
export const PREVIEW_MODE_DATE_PARAM = '__preview_date';
export const PREVIEW_REFRESH_PATHNAME = '/__pwa-kit/refresh';

/**
 * This list contains domains that can host code in iframe
 */
export const IFRAME_HOST_ALLOW_LIST = new Set([
    'https://runtime.commercecloud.com',
    'https://runtime-admin-staging.mobify-storefront.com',
    'https://runtime-admin-preview.mobify-storefront.com',
]);

export const detectInIframe = (): boolean =>
    typeof window !== 'undefined' && window.top !== window.self;

export const getParentOrigin = (): string => {
    if (detectInIframe()) {
        // location.ancestorOrigins[0] will provide the parent host url, but it only works for Chrome and Safari.
        // Firefox does not have this field. document.referrer is common use for parent url, but it could be less reliable.
        // It is best to use it a fallback option for Firefox
        if (window.location.ancestorOrigins) return window.location.ancestorOrigins[0];
        if (document.referrer) return new URL(document.referrer).origin;
    }
    return '';
};

export const detectStorefrontPreview = (): boolean =>
    detectInIframe() && IFRAME_HOST_ALLOW_LIST.has(getParentOrigin());

export const isNotAccessibleTopOrigin = (): boolean => {
    const { top } = window;
    // if not iframe return false, since it is not cross-origin
    if (window.self === window.top) {
        return false;
    }
    try {
        const topLocation = top?.location.origin ?? null;
        if (!topLocation) {
            return true; // not accessible top origin, since it is null
        }
        // if somehow the top origin is accessible, check if it is cross-origin
        return topLocation !== new URL(window.location.href).origin;
    } catch (error) {
        return true; // not accessible top origin, since it failed to get the origin
    }
};

export function isValidDateString(dateString: string): boolean {
    if (!dateString) {
        return false;
    }
    try {
        const date = new Date(dateString);
        return !Number.isNaN(date.valueOf());
    } catch (error) {
        return false;
    }
}

export function cleanEffectiveDateTime(dateTimeString: string | undefined | null): string {
    if (!dateTimeString) {
        return '';
    }
    if (isValidDateString(dateTimeString)) {
        return new Date(dateTimeString).toISOString();
    }
    return '';
}
